var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 4.99984C11.667 5.92031 10.9208 6.6665 10.0003 6.6665C9.07984 6.6665 8.33367 5.92031 8.33367 4.99984C8.33367 4.07936 9.07984 3.33317 10.0003 3.33317C10.9208 3.33317 11.667 4.07936 11.667 4.99984ZM12.8877 6.6665C13.1713 6.17621 13.3337 5.60698 13.3337 4.99984C13.3337 3.15889 11.8413 1.6665 10.0003 1.6665C8.15935 1.6665 6.66697 3.15889 6.66697 4.99984C6.66697 5.60698 6.82929 6.17621 7.11291 6.6665H4.22179C3.81574 6.6665 3.46879 6.95917 3.40038 7.35942L1.83342 16.5261C1.74642 17.0351 2.13849 17.4998 2.65484 17.4998H17.3458C17.8621 17.4998 18.2542 17.0351 18.1672 16.5261L16.6003 7.35942C16.5318 6.95917 16.1848 6.6665 15.7788 6.6665H12.8877Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.ea5795536398126494afadda76e4e21c.svg";
export { ForwardRef as ReactComponent };